import { render, staticRenderFns } from "./detailPanel.vue?vue&type=template&id=28620d4e&scoped=true&"
import script from "./detailPanel.vue?vue&type=script&lang=js&"
export * from "./detailPanel.vue?vue&type=script&lang=js&"
import style0 from "./detailPanel.vue?vue&type=style&index=0&id=28620d4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28620d4e",
  null
  
)

export default component.exports